import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocShowAddressEditState = atom({
  key: "ocShowAddressEditState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
